import React from 'react';
import GifLoader from '../Loading/GifLoader';
import './EmptyPageLoader.scss';

const EmptyPageLoader = () => (
  <div className="empty-page-loader-cover"><GifLoader /></div>
);
export default EmptyPageLoader;
